import { ActionsUnion, createAction } from 'spw-redux/types';
import { INote } from 'spw-redux/modules/notes/types';
import { LatLngLiteral } from 'leaflet';
import {
  MeasurementState,
  FloorMapStates,
  IFloorplan,
  IFloorplanControlsState,
  IUnattachedNote,
  ICalibration,
  ISpaceShape,
  ICluster,
  ISpace,
  BulkSelectionState,
  TooltipPositionState,
  SpaceShapeVM,
  IFloorplanMiniModalState,
  IFloorplanDialogState,
  IMinimalSpace,
  EditCommand,
  FloorplanUpload,
  ToolbarMode,
  PreviewState,
  IAdjustedFloorplanItems,
  ISelectedSpaceLayer,
  SuggestedCalibration,
} from './types';
import { IFloor } from '../projects/types';

export const FETCH_FLOORPLAN = 'floorplan/FETCH_FLOORPLAN';
export const FETCH_FLOORPLAN_SUCCEEDED = 'floorplan/FETCH_FLOORPLAN_SUCCEEDED';
export const FETCH_FLOORPLAN_UPLOAD = 'floorplan/FETCH_FLOORPLAN_UPLOAD';
export const FETCH_FLOORPLAN_GEOJSON = 'floorplan/FETCH_FLOORPLAN_GEOJSON';
export const SET_FLOORPLAN_GEOJSON = 'floorplan/SET_FLOORPLAN_GEOJSON';
export const SET_FLOORPLAN = 'floorplan/SET_FLOORPLAN';
export const FETCH_FLOORPLAN_FAILED = 'floorplan/FETCH_FLOORPLAN_FAILED';
export const SET_IS_UPLOADING_FLOORPLAN =
  'floorplan/SET_IS_UPLOADING_FLOORPLAN';
export const UPLOAD_FLOORPLAN = 'floorplan/UPLOAD_FLOORPLAN';
export const ARCHIVE_FLOORPLAN = 'floorplan/ARCHIVE_FLOORPLAN';
export const SET_IS_ARCHIVING_FLOORPLAN = 'floorplan/IS_ARCHIVING_FLOORPLAN';
export const UPLOAD_FLOORPLAN_SUCCEEDED =
  'floorplan/UPLOAD_FLOORPLAN_SUCCEEDED';
export const UPLOAD_FLOORPLAN_FAILED = 'floorplan/UPLOAD_FLOORPLAN_FAILED';
export const SET_FLOOR_IMAGE = 'floorplan/SET_FLOOR_IMAGE';
export const SET_FLOORPLAN_IMAGE = 'floorplan/SET_FLOORPLAN_IMAGE';
export const SET_CURRENT_FLOORPLAN_UPLOAD =
  'floorplan/SET_CURRENT_FLOORPLAN_UPLOAD';
export const CLEAN_EDIT_HISTORY = 'floorplan/CLEAN_EDIT_HISTORY';
export const SET_ORIGINAL_IMAGE_DIMENSIONS =
  'floorplan/SET_ORIGINAL_IMAGE_DIMENSIONS';
export const ADD_ITEM_TO_EDIT_HISTORY = 'floorplan/ADD_ITEM_TO_EDIT_HISTORY';
export const SAVE_FLOOR_IMAGE = 'floorplan/SAVE_FLOOR_IMAGE';
export const CANCEL_FLOOR_PLAN_IMAGE = 'floorplan/CANCEL_FLOOR_PLAN_IMAGE';
export const SHOW_CANCEL_UPLOAD = 'floorplan/SHOW_CANCEL_UPLOAD';
export const RESET_FLOORPLAN = 'floorplan/RESET_FLOORPLAN';
export const SET_IS_LOADING_FLOORPLAN_IMAGE =
  'floorplan/SET_IS_LOADING_FLOORPLAN_IMAGE';
export const ADD_SPACE = 'floorplan/ADD_SPACE';
export const SET_FLOOR_MAP_STATE = 'floorplan/SET_FLOORMAP_STATE';
export const CONFIRM_ADD_SPACE = 'floorplan/CONFIRM_ADD_SPACE';
export const CANCEL_ADD_SPACE = 'floorplan/CANCEL_ADD_SPACE';
export const GET_SPACES = 'floorplan/GET_SPACES';
export const GET_SPACES_SUCCEEDED = 'floorplan/GET_SPACES_SUCCEEDED';
export const GET_FLOOR_SPACES_SUCCEEDED =
  'floorplan/GET_FLOOR_SPACES_SUCCEEDED';
export const TOGGLE_INDIVIDUAL_SPACES = 'floorplan/TOGGLE_INDIVIDUAL_SPACES';
export const TOGGLE_INDIVIDUAL_SPACES_SUCCESS =
  'floorplan/TOGGLE_INDIVIDUAL_SPACES_SUCCESS';
export const TOGGLE_MEETING_SPACES = 'floorplan/TOGGLE_MEETING_SPACES';
export const TOGGLE_AMENITY_SPACES = 'floorplan/TOGGLE_AMENITY_SPACES';
export const TOGGLE_SUPPORT_SPACES = 'floorplan/TOGGLE_SUPPORT_SPACES';
export const TOGGLE_ONLY_WITH_PHOTO = 'floorplan/TOGGLE_ONLY_WITH_PHOTO';
export const TOGGLE_ONLY_WITH_NOTE = 'floorplan/TOGGLE_ONLY_WITH_NOTE';
export const UPDATE_SPACE = 'floorplan/UPDATE_SPACE';
export const UPDATE_SPACE_BUBBLE_POSITION =
  'floorplan/UPDATE_SPACE_BUBBLE_POSITION';
export const UPDATE_SPACE_POSITION = 'floorplan/UPDATE_SPACE_POSITION';
export const LAYERS_BUILT_SUCCEEDED = 'floorplan/LAYERS_BUILT_SUCCEEDED';
export const SEAT_COUNT_CLICKED = 'floorplan/SEAT_COUNT_CLICKED';
export const SPACE_TYPE_CLICKED = 'floorplan/SPACE_TYPE_CLICKED';
export const VIEW_SPACES_USF_CLICKED = 'floorplan/VIEW_SPACES_USF_CLICKED';
export const PHOTO_FILTER_CLICKED = 'floorplan/PHOTO_FILTER_CLICKED';
export const NOTE_FILTER_CLICKED = 'floorplan/NOTE_FILTER_CLICKED';
export const SHOW_SEATCOUNT_LAYER = 'floorplan/SHOW_SEATCOUNT_LAYER';
export const SHOW_SPACETYPE_LAYER = 'floorplan/SHOW_SPACETYPE_LAYER';
export const SET_SHOW_SPACES_USF_LAYER = 'floorplan/SET_SHOW_SPACES_USF_LAYER';
export const ENABLE_SEATCOUNT_BUTTON = 'floorplan/ENABLE_SEATCOUNT_BUTTON';
export const SET_CONTROLS_STATE = 'floorplan/SET_CONTROLS_STATE';

export const RESTORE_CONTROLS_STATE = 'floorplan/RESTORE_FLOORMAP_STATE';
export const SET_ADD_FLOOR_NOTE_STATE = 'floorplan/SET_ADD_FLOOR_NOTE_STATE';
export const SET_SELECTED_SPACE = 'floorplan/SET_SELECTED_SPACE';
export const CLEAR_SELECTED_SPACE = 'floorplan/CLEAR_SELECTED_SPACE';
export const GET_SPACE_TO_UPDATE = 'floorplan/GET_SPACE_TO_UPDATE';
export const SET_SPACE_TO_UPDATE = 'floorplan/SET_SPACE_TO_UPDATE';
export const ATTACH_NOTE = 'floorplan/ATTACH_NOTE';
export const ATTACH_NOTE_SUCCEEDED = 'floorplan/ATTACH_NOTE_SUCCEEDED';
export const ENABLE_ALL_VIEW_LAYERS = 'floorplan/ENABLE_ALL_VIEW_LAYERS';
export const ADD_UNATTACHED_NOTE = 'floorplan/ADD_UNATTACHED_NOTE';
export const TOGGLE_OTHER_SPACES = 'floorplan/TOGGLE_OTHER_SPACES';
export const REMOVE_SPACE_SHAPE = 'floorplan/REMOVE_SPACE_SHAPE';
export const DELETE_SPACE = 'floorplan/DELETE_SPACE';
export const TOGGLE_WORKSPACE_INTERMEDIATE =
  'floorplan/TOGGLE_WORKSPACE_INTERMEDIATE';
export const PUT_DISTANCE_CONSTANT = 'floorplan/PUT_DISTANCE_CONSTANT';
export const PUSH_POINT_TO_AREA = 'floorplan/PUSH_POINT_TO_AREA';

export const SET_TOOLBAR_MODE = 'floorplan/SET_TOOLBAR_MODE';
export const SET_MEASUREMENT_STATE = 'floorplan/SET_MEASUREMENT_STATE';
export const START_COPYING_FLOOR_USF_SHAPE =
  'floorplan/START_COPYING_FLOOR_USF_SHAPE';
export const CLEAN_COPYING_FLOOR_USF_SHAPE_STATE =
  'floorplan/CLEAN_COPYING_FLOOR_USF_SHAPE_STATE';
export const COPY_MEASURED_FLOOR_USF = 'floorplan/COPY_MEASURED_FLOOR_USF';
export const FINISHED_COPYING_FLOOR_USF_SHAPE =
  'floorplan/FINISHED_COPYING_FLOOR_USF_SHAPE';
export const POPULATE_CALIBRATION = 'floorplan/POPUlATE_CALIBRATION';
export const FETCH_CALIBRATION = 'floorplan/FETCH_CALIBRATION';
export const FETCH_CALIBRATION_SUCCEEDED =
  'floorplan/FETCH_CALIBRATION_SUCCEEDED';
export const FETCH_SUGGESTED_CALIBRATION =
  'floorplan/FETCH_SUGGESTED_CALIBRATION';
export const FETCH_SUGGESTED_CALIBRATION_SUCCEEDED =
  'floorplan/FETCH_SUGGESTED_CALIBRATION_SUCCEEDED';
export const SET_SUGGESTED_CALIBRATION = 'floorplan/SET_SUGGESTED_CALIBRATION';
export const UPDATE_SUGGESTED_CALIBRATION =
  'floorplan/UPDATE_SUGGESTED_CALIBRATION';
export const SET_IS_DRAWING_CALIBRATION =
  'floorplan/SET_IS_DRAWING_CALIBRATION';
export const SET_PREVIOUS_MAP_BOUNDS_AND_ZOOM =
  'floorplan/SET_PREVIOUS_MAP_BOUNDS_AND_ZOOM';
export const SET_IS_MEASURED_SHAPE_DIRTY =
  'floorplan/SET_IS_MEASURED_SHAPE_DIRTY';

export const SET_ACTIVE_SHAPE = 'floorplan/SET_ACTIVE_SHAPE';
export const SET_ORIGINAL_SHAPE = 'floorplan/SET_ORIGINAL_SHAPE';
export const SAVE_ACTIVE_SHAPE = 'floorplan/SAVE_ACTIVE_SHAPE';
export const FETCH_FLOORPLAN_SHAPES = 'floorplan/FETCH_FLOORPLAN_SHAPES';
export const POPULATE_FLOORPLAN_SHAPES = 'floorplan/POPULATE_FLOORPLAN_SHAPES';
export const UPDATE_ACTIVE_SHAPE = 'floorplan/UPDATE_ACTIVE_SHAPE';
export const DELETE_ACTIVE_SHAPE = 'floorplan/DELETE_ACTIVE_SHAPE';
export const DELETE_SHAPE = 'floorplan/DELETE_SHAPE';

export const DELETE_NOTE = 'floorplan/DELETE_NOTE';
export const UPDATE_NOTE = 'floorplan/UPDATE_NOTE';

export const POPULATE_CLUSTERS = 'floorplan/POPULATE_CLUSTERS';
export const UPDATE_CLUSTER = 'floorplan/UPDATE_CLUSTER';
export const DELETE_CLUSTER = 'floorplan/DELETE_CLUSTER';
export const DELETE_CLUSTER_SUCCEEDED = 'floorplan/DELETE_CLUSTER_SUCCEEDED';
export const DELETE_CLUSTER_FAILED = 'floorplan/DELETE_CLUSTER_FAILED';
export const CREATE_SPACE_FROM_CLUSTER = 'floorplan/CREATE_SPACE_FROM_CLUSTER';
export const SET_DID_UPDATE_FLOOR_PLAN = 'floorplan/SET_DID_UPDATE_FLOOR_PLAN';
export const START_PDF_UPLOAD = 'floorplan/START_PDF_UPLOAD';
export const SET_IS_UPLOADING_PDF = 'floorplan/IS_UPLOADING_PDF';
export const CANCEL_PDF_UPLOAD = 'floorplan/CANCEL_PDF_UPLOAD';

export const SET_WORKING_LAYER = 'floorplan/SET_WORKING_LAYER';
export const SET_BULK_SELECTION_STATE = 'floorplan/SET_BULK_SELECTION_STATE';
export const SET_SELECTED_SPACES = 'floorplan/SET_SELECTED_SPACES';
export const DELETE_SELECTED_SPACES = 'floorplan/DELETE_SELECTED_SPACES';
export const CREATE_SPACES = 'floorplan/CREATE_SPACES';
export const UPDATE_MULTIPLE_SPACES = 'floorplan/UPDATE_MULTIPLE_SPACES';
export const SET_SELECTION_SHAPE_POINTS =
  'floorplan/SET_SELECTION_SHAPE_POINTS';
export const SET_ORIGINAL_FILE_DATA_URL =
  'floorplan/SET_ORIGINAL_FILE_DATA_URL';
export const EXIT_FLOORPLAN_OPERATION = 'floorplan/EXIT_FLOORPLAN_OPERATION';
export const EXIT_FLOORPLAN_OPERATION_CONFIRM =
  'floorplan/EXIT_FLOORPLAN_OPERATION_CONFIRM';
export const EXIT_FLOORPLAN_OPERATION_CANCEL =
  'floorplan/EXIT_FLOORPLAN_OPERATION_CANCEL';
export const SET_TOOLTIP_STATE = 'floorplan/SET_TOOLTIP_STATE';
export const SET_MINI_MODAL_STATE = 'floorplan/SET_MINI_MODAL_STATE';
export const SET_ADD_NOTE_DIALOG_STATE = 'floorplan/SET_ADD_NOTE_DIALOG_STATE';
export const SET_ADD_SPACE_DIALOG_STATE =
  'floorplan/SET_ADD_SPACE_DIALOG_STATE';
export const SET_MAP_MOUNTED = 'floorplan/SET_MAP_MOUNTED';
export const FETCH_SPACES_WORKSHEET_SPREADSHEET =
  'floorplan/FETCH_SPACES_WORKSHEET_SPREADSHEET';
export const FETCH_SPACES_WORKSHEET_SPREADSHEET_SUCCESS =
  'floorplan/FETCH_SPACES_WORKSHEET_SPREADSHEET_SUCCESS';
export const FETCH_SPACES_WORKSHEET_SPREADSHEET_FAILED =
  'floorplan/FETCH_SPACES_WORKSHEET_SPREADSHEET_FAILED';
export const FETCH_FLOORPLAN_PDF = 'floorplan/FETCH_FLOORPLAN_PDF';
export const FETCH_FLOORPLAN_PDF_SUCCESS =
  'floorplan/FETCH_FLOORPLAN_PDF_SUCCESS';
export const FETCH_FLOORPLAN_PDF_FAILED =
  'floorplan/FETCH_FLOORPLAN_PDF_FAILED';

export const SET_CONTROL_STATE_VALUE = 'floorplan/SET_CONTROL_STATE_VALUE';
export const SET_FLOORPLAN_PREVIEW_STATE =
  'floorplan/SET_FLOORPLAN_PREVIEW_STATE';
export const SET_FLOORPLAN_PREVIEW_IMAGE_BOUNDS =
  'floorplan/SET_FLOORPLAN_PREVIEW_IMAGE_BOUNDS';
export const CROP_FLOORPLAN_IMAGE = 'floorplan/CROP_FLOORPLAN_IMAGE';

export const SET_BULK_OPERATION_SOURCE_FLOOR_DATA =
  'floorplan/SET_BULK_OPERATION_SOURCE_FLOOR_DATA';

export const SET_ADJUSTED_FLOORPLAN_ITEMS =
  'floorplan/SET_ADJUSTED_FLOORPLAN_ITEMS';

export const SET_CHANGES_FOR_BULK_OPERATION_ARE_PENDING =
  'floorplan/SET_CHANGES_FOR_BULK_OPERATION_ARE_PENDING';

export const startPDFUpload = (pdf: File, floorId: number) =>
  createAction(START_PDF_UPLOAD, { pdf, floorId });
export const setIsUploadingPDF = (isUploadingPDF: boolean) =>
  createAction(SET_IS_UPLOADING_PDF, { isUploadingPDF });
export const getSpaceToUpdate = (space: ISpace) =>
  createAction(GET_SPACE_TO_UPDATE, { space });
export const setSpaceToUpdate = (space: ISpace) =>
  createAction(SET_SPACE_TO_UPDATE, { space });
export const fetchFloorplan = (floorId: number) =>
  createAction(FETCH_FLOORPLAN, { floorId });
export const fetchFloorplanUpload = (floorId: number) =>
  createAction(FETCH_FLOORPLAN_UPLOAD, { floorId });
export const setIsUploadingFloorplan = (isUploadingFloorplan: boolean) =>
  createAction(SET_IS_UPLOADING_FLOORPLAN, { isUploadingFloorplan });
export const fetchFloorplanSucceeded = (floorplan: IFloorplan) =>
  createAction(FETCH_FLOORPLAN_SUCCEEDED, { floorplan });
export const fetchFloorplanGeoJson = (floorId: number) =>
  createAction(FETCH_FLOORPLAN_GEOJSON, { floorId });
export const setFloorplanGeoJson = (floorplanGeoJson: GeoJSON.GeoJsonObject) =>
  createAction(SET_FLOORPLAN_GEOJSON, floorplanGeoJson);
export const setFloorplan = (floorplan: IFloorplan) =>
  createAction(SET_FLOORPLAN, { floorplan });
export const fetchFloorplanFailed = () =>
  createAction(FETCH_FLOORPLAN_FAILED, {});
export const uploadFloorplan = (image: File, floor: IFloor) =>
  createAction(UPLOAD_FLOORPLAN, { image, floor });
export const uploadFloorplanSucceeded = (floorplan: IFloorplan) =>
  createAction(UPLOAD_FLOORPLAN_SUCCEEDED, { floorplan });
export const uploadFloorplanFailed = () =>
  createAction(UPLOAD_FLOORPLAN_FAILED);
export const archiveFloorplan = (floorId: number) =>
  createAction(ARCHIVE_FLOORPLAN, { floorId });
export const setIsArchivingFloorplan = (isArchivingFloorplan: boolean) =>
  createAction(SET_IS_ARCHIVING_FLOORPLAN, { isArchivingFloorplan });
export const setDidUpdateFloorPlan = (didUpdate: boolean) =>
  createAction(SET_DID_UPDATE_FLOOR_PLAN, { didUpdate });
export const setFloorplanImage = (s3Path: string) =>
  createAction(SET_FLOORPLAN_IMAGE, { s3Path });
export const setCurrentFloorplanUpload = (floorplanUpload: FloorplanUpload) =>
  createAction(SET_CURRENT_FLOORPLAN_UPLOAD, { floorplanUpload });
export const cleanEditHistory = () => createAction(CLEAN_EDIT_HISTORY);
export const setOriginalImageDimensions = (dimensions: {
  width: number;
  height: number;
}) => createAction(SET_ORIGINAL_IMAGE_DIMENSIONS, { dimensions });
export const addItemToEditHistory = (editingCommand: EditCommand) =>
  createAction(ADD_ITEM_TO_EDIT_HISTORY, { editingCommand });
export const setFloorImage = (image: string | null) =>
  createAction(SET_FLOOR_IMAGE, { image });

export const saveFloorImage = () => createAction(SAVE_FLOOR_IMAGE);

export const cancelFloorPlanImage = () => createAction(CANCEL_FLOOR_PLAN_IMAGE);
export const showCancelUpload = (show = true) =>
  createAction(SHOW_CANCEL_UPLOAD, { show });
export const resetFloorplan = () => createAction(RESET_FLOORPLAN);
export const addSpace = () => createAction(ADD_SPACE);
export const setFloormapState = (state: FloorMapStates) =>
  createAction(SET_FLOOR_MAP_STATE, { state });
export const setMiniModalState = (state: IFloorplanMiniModalState) =>
  createAction(SET_MINI_MODAL_STATE, { ...state });
export const setAddNoteDialogState = (state: IFloorplanDialogState) =>
  createAction(SET_ADD_NOTE_DIALOG_STATE, { ...state });
export const setAddSpaceDialogState = (state: IFloorplanDialogState) =>
  createAction(SET_ADD_SPACE_DIALOG_STATE, { ...state });
export const confirmAddSpace = (
  space: IMinimalSpace | ICluster,
  options?: {
    notesToAttach?: string;
    shouldNotShowSuccessToast?: boolean;
    shouldNotSelectSpace?: boolean;
  }
) => createAction(CONFIRM_ADD_SPACE, { space, ...options });
export const cancelAddSpace = () => createAction(CANCEL_ADD_SPACE);
export const getSpaces = (floorId: number) =>
  createAction(GET_SPACES, { floorId });
export const getSpacesSucceeded = (spacesMap: Map<string, ISpace[]>) =>
  createAction(GET_SPACES_SUCCEEDED, { spacesMap });
export const getFloorSpacesSucceeded = (
  floorSpaces: Record<string, ISpace[]>
) => createAction(GET_FLOOR_SPACES_SUCCEEDED, { floorSpaces });
export const toggleIndividualSpaces = (payload: {
  categoryHasAlternativeWorkpoint: boolean;
}) => createAction(TOGGLE_INDIVIDUAL_SPACES, payload);
export const toggleIndividualSpacesSuccess = (show?: boolean) =>
  createAction(TOGGLE_INDIVIDUAL_SPACES_SUCCESS, { show });
export const layersBuildSucceeded = () => createAction(LAYERS_BUILT_SUCCEEDED);
export const enableSeatCountButton = (enable: boolean) =>
  createAction(ENABLE_SEATCOUNT_BUTTON, { enable });
export const setAddFloorNoteState = () =>
  createAction(SET_ADD_FLOOR_NOTE_STATE);

export const setControlStateValue = (
  key: keyof IFloorplanControlsState,
  value: boolean
) => createAction(SET_CONTROL_STATE_VALUE, { key, value });

export const toggleMeetingSpaces = (payload: {
  categoryHasAlternativeWorkpoint: boolean;
}) => createAction(TOGGLE_MEETING_SPACES, payload);

export const toggleAmenitySpaces = (payload: {
  categoryHasAlternativeWorkpoint: boolean;
}) => createAction(TOGGLE_AMENITY_SPACES, payload);
export const toggleSupportSpaces = (payload: {
  categoryHasAlternativeWorkpoint: boolean;
}) => createAction(TOGGLE_SUPPORT_SPACES, payload);
export const toggleOtherSpaces = (show?: boolean) =>
  createAction(TOGGLE_OTHER_SPACES, { show });
export const toggleOnlyWithPhoto = (show?: boolean) =>
  createAction(TOGGLE_ONLY_WITH_PHOTO, { show });
export const updateSpace = (
  space: ISpace,
  options?: {
    shouldRefetch?: boolean;
    shouldUpdateSelectedSpace?: boolean;
    shouldRemoveSpaceShape?: boolean;
    shouldUpdateUsf?: boolean;
    shouldClearActiveShape?: boolean;
  }
) => createAction(UPDATE_SPACE, { space, ...options });
export const updateSpaceBubblePosition = (space: ISpace) =>
  createAction(UPDATE_SPACE_BUBBLE_POSITION, { space });
export const updateSpacePosition = (
  spaceId: number,
  category: string,
  previousSpaceId: number | null,
  nextSpaceId: number | null
) =>
  createAction(UPDATE_SPACE_POSITION, {
    spaceId,
    category,
    previousSpaceId,
    nextSpaceId,
  });
export const toggleOnlyWithNote = (show?: boolean) =>
  createAction(TOGGLE_ONLY_WITH_NOTE, { show });
export const seatCountClicked = () => createAction(SEAT_COUNT_CLICKED);
export const spaceTypeClicked = () => createAction(SPACE_TYPE_CLICKED);
export const viewSpacesUSFClicked = () => createAction(VIEW_SPACES_USF_CLICKED);
export const photoFilterClicked = () => createAction(PHOTO_FILTER_CLICKED);
export const noteFilterClicked = () => createAction(NOTE_FILTER_CLICKED);
export const showSeatCountLayer = (show: boolean) =>
  createAction(SHOW_SEATCOUNT_LAYER, { show });
export const showSpaceTypeLayer = (show: boolean) =>
  createAction(SHOW_SPACETYPE_LAYER, { show });
export const setShowSpacesUSFLayer = (show: boolean) =>
  createAction(SET_SHOW_SPACES_USF_LAYER, { show });
export const setControlsState = (
  state: IFloorplanControlsState | Partial<IFloorplanControlsState>
) => createAction(SET_CONTROLS_STATE, { state });
export const restoreControlsState = () => createAction(RESTORE_CONTROLS_STATE);
export const setToolbarMode = (toolbarMode: ToolbarMode) =>
  createAction(SET_TOOLBAR_MODE, toolbarMode);
export const setMeasurementState = (newMeasurementState: MeasurementState) =>
  createAction(SET_MEASUREMENT_STATE, newMeasurementState);
export const startCopyingFloorUsfShape = (
  sourceFloor: IFloor,
  shape: SpaceShapeVM,
  calibration: ICalibration
) =>
  createAction(START_COPYING_FLOOR_USF_SHAPE, {
    sourceFloor,
    shape,
    calibration,
  });
export const cleanCopyingFloorUsfShapeState = () =>
  createAction(CLEAN_COPYING_FLOOR_USF_SHAPE_STATE);
export const copyMeasuredFloorUsf = (
  inputPolygons: { x: number; y: number }[][][],
  calibration: ICalibration,
  targetFloor: IFloor,
  callback: () => void
) =>
  createAction(COPY_MEASURED_FLOOR_USF, {
    inputPolygons,
    calibration,
    targetFloor,
    callback,
  });
export const finishedCopyingFloorUsfShape = () =>
  createAction(FINISHED_COPYING_FLOOR_USF_SHAPE);
export const setSelectedSpace = (space: ISpace) =>
  createAction(SET_SELECTED_SPACE, { space });
export const clearSelectedSpace = () => createAction(CLEAR_SELECTED_SPACE);
export const attachNote = (space: ISpace, text: string) =>
  createAction(ATTACH_NOTE, { space, text });
export const attachNoteSucceeded = (noteId: number) =>
  createAction(ATTACH_NOTE_SUCCEEDED, { noteId });
export const enableAllViewLayers = () => createAction(ENABLE_ALL_VIEW_LAYERS);
export const addUnattachedNote = (note: IUnattachedNote) =>
  createAction(ADD_UNATTACHED_NOTE, { note });
export const putDistanceConstant = (calibration: ICalibration) =>
  createAction(PUT_DISTANCE_CONSTANT, calibration);
export const populateCalibration = (calibration: ICalibration) =>
  createAction(POPULATE_CALIBRATION, calibration);
export const fetchCalibration = () => createAction(FETCH_CALIBRATION);
export const fetchCalibrationSucceeded = (calibration: ICalibration) =>
  createAction(FETCH_CALIBRATION_SUCCEEDED, calibration);
export const fetchSuggestedCalibration = () =>
  createAction(FETCH_SUGGESTED_CALIBRATION);
export const fetchSuggestedCalibrationSucceeded = (
  suggestedCalibration: SuggestedCalibration
) => createAction(FETCH_SUGGESTED_CALIBRATION_SUCCEEDED, suggestedCalibration);
export const setSuggestedCalibration = (
  suggestedCalibration: SuggestedCalibration
) => createAction(SET_SUGGESTED_CALIBRATION, suggestedCalibration);
export const updateSuggestedCalibration = (
  suggestedCalibration: SuggestedCalibration
) => createAction(UPDATE_SUGGESTED_CALIBRATION, suggestedCalibration);
export const setIsDrawingCalibration = (isDrawing: boolean) =>
  createAction(SET_IS_DRAWING_CALIBRATION, isDrawing);
export const setPreviousMapBoundsAndZoom = (boundsAndZoom: {
  bounds: L.LatLngBoundsExpression;
  zoom: number;
}) => createAction(SET_PREVIOUS_MAP_BOUNDS_AND_ZOOM, boundsAndZoom);

export const setIsMeasuredShapeDirty = (dirty: boolean) =>
  createAction(SET_IS_MEASURED_SHAPE_DIRTY, dirty);

export const pushPointToArea = (point: any) =>
  createAction(PUSH_POINT_TO_AREA, point);

export const removeSpaceShape = (id: number) =>
  createAction(REMOVE_SPACE_SHAPE, { id });

export const deleteSpace = (spaceId: number, callback?: () => void) =>
  createAction(DELETE_SPACE, { spaceId, callback });
export const setIsLoadingFloorplanImage = (
  isLoadingFloorplanImage: boolean,
  from?: string
) =>
  createAction(SET_IS_LOADING_FLOORPLAN_IMAGE, {
    isLoadingFloorplanImage,
    from,
  });

export const toggleWorkspaceIntermediate = (state: boolean) =>
  createAction(TOGGLE_WORKSPACE_INTERMEDIATE, { state });

export const setActiveShape = (shape: SpaceShapeVM | null) =>
  createAction(SET_ACTIVE_SHAPE, { shape });

export const setOriginalShape = (shape: SpaceShapeVM | null) =>
  createAction(SET_ORIGINAL_SHAPE, shape);

export const saveActiveShape = () => createAction(SAVE_ACTIVE_SHAPE);

export const fetchFloorplanShapes = (options?: {
  measurementStateAfterFetching?: MeasurementState;
}) => createAction(FETCH_FLOORPLAN_SHAPES, options);
export const populateFloorplanShapes = (shapes: ISpaceShape[]) =>
  createAction(POPULATE_FLOORPLAN_SHAPES, shapes);

export const updateShape = () => createAction(UPDATE_ACTIVE_SHAPE);

export const deleteActiveShape = () => createAction(DELETE_ACTIVE_SHAPE);

export const deleteNote = (noteId: number) =>
  createAction(DELETE_NOTE, { noteId });

export const updateNote = (noteId: number, newNote: Partial<INote>) =>
  createAction(UPDATE_NOTE, { noteId, newNote });

export const deleteShape = (id: number) => createAction(DELETE_SHAPE, { id });

export const populateClusters = (clusters: ICluster[]) =>
  createAction(POPULATE_CLUSTERS, { clusters });

export const updateCluster = (cluster: ICluster) =>
  createAction(UPDATE_CLUSTER, { cluster });

export const deleteCluster = (id: number) =>
  createAction(DELETE_CLUSTER, { id });
export const deleteClusterSucceded = () =>
  createAction(DELETE_CLUSTER_SUCCEEDED);
export const deleteClusterFailed = () => createAction(DELETE_CLUSTER_FAILED);

export const createSpaceFromCluster = (cluster: ICluster, space: ISpace) =>
  createAction(CREATE_SPACE_FROM_CLUSTER, { cluster, space });

export const setWorkingLayer = (workingLayer: any) =>
  createAction(SET_WORKING_LAYER, workingLayer);

export const setBulkSelectionState = (state: BulkSelectionState) =>
  createAction(SET_BULK_SELECTION_STATE, state);

export const setSelectedSpaceLayers = (
  selectedSpacesWithShapes: ISelectedSpaceLayer[]
) => createAction(SET_SELECTED_SPACES, selectedSpacesWithShapes);

export const setBulkOperationSourceFloorData = (sourceFloorData: {
  floorName: string;
  calibration: ICalibration;
}) => createAction(SET_BULK_OPERATION_SOURCE_FLOOR_DATA, sourceFloorData);

export const deleteSelectedSpaces = () => createAction(DELETE_SELECTED_SPACES);
export const createSpaces = (spaces: ISpace[]) =>
  createAction(CREATE_SPACES, { spaces });

export const updateMultipleSpaces = (
  spaces: ISpace[],
  options?: {
    markersShouldRemainSelected: boolean;
    spaceShapes?: ISpaceShape[];
  }
) => createAction(UPDATE_MULTIPLE_SPACES, { spaces, options });

export const setSelectionShapePoints = (points: LatLngLiteral[][]) =>
  createAction(SET_SELECTION_SHAPE_POINTS, points);

export const setOriginalFileDataUrl = (originalFileDataUrl: string) =>
  createAction(SET_ORIGINAL_FILE_DATA_URL, { originalFileDataUrl });

export const exitFloorplanOperation = (onConfirm?: () => void) =>
  createAction(EXIT_FLOORPLAN_OPERATION, { onConfirm });

export const exitFloorplanOperationConfirm = () =>
  createAction(EXIT_FLOORPLAN_OPERATION_CONFIRM);

export const exitFloorplanOperationCancel = () =>
  createAction(EXIT_FLOORPLAN_OPERATION_CANCEL);

export const setTooltipPositionState = (
  tooltipPositionState: TooltipPositionState
) =>
  createAction(SET_TOOLTIP_STATE, {
    tooltipPositionState,
  });

export const setFloorplanPreviewState = (previewState: PreviewState) =>
  createAction(SET_FLOORPLAN_PREVIEW_STATE, previewState);

export const setMapMounted = (mapMounted: boolean) =>
  createAction(SET_MAP_MOUNTED, { mapMounted });
export const fetchSpacesWorksheetSpreadsheet = (floorId: number) =>
  createAction(FETCH_SPACES_WORKSHEET_SPREADSHEET, { floorId });
export const fetchSpacesWorksheetSpreadsheetSuccess = () =>
  createAction(FETCH_SPACES_WORKSHEET_SPREADSHEET_SUCCESS);
export const fetchSpacesWorksheetSpreadsheetFailed = () =>
  createAction(FETCH_SPACES_WORKSHEET_SPREADSHEET_FAILED);
export const fetchFloorplanPDF = () => createAction(FETCH_FLOORPLAN_PDF);
export const fetchFloorplanPDFSuccess = () =>
  createAction(FETCH_FLOORPLAN_PDF_SUCCESS);
export const fetchFloorplanPDFFailed = () =>
  createAction(FETCH_FLOORPLAN_PDF_FAILED);
export const setFloorplanPreviewImageBounds = (imageBounds: L.LatLngBounds) =>
  createAction(SET_FLOORPLAN_PREVIEW_IMAGE_BOUNDS, imageBounds);
export const cropFloorplanImage = (cropBounds: L.LatLngBounds) =>
  createAction(CROP_FLOORPLAN_IMAGE, { cropBounds });
export const setAdjustedFloorplanItems = (items: IAdjustedFloorplanItems) =>
  createAction(SET_ADJUSTED_FLOORPLAN_ITEMS, items);

export const setChangesForBulkOperationArePending = (val: boolean) =>
  createAction(SET_CHANGES_FOR_BULK_OPERATION_ARE_PENDING, val);

export const actions = {
  setMiniModalState,
  setAddNoteDialogState,
  setAddSpaceDialogState,
  setFloorplan,
  fetchFloorplan,
  fetchFloorplanUpload,
  setIsUploadingFloorplan,
  fetchFloorplanSucceeded,
  fetchFloorplanFailed,
  fetchFloorplanGeoJson,
  setFloorplanGeoJson,
  uploadFloorplan,
  uploadFloorplanSucceeded,
  uploadFloorplanFailed,
  archiveFloorplan,
  setIsArchivingFloorplan,
  setDidUpdateFloorPlan,
  setFloorplanImage,
  setCurrentFloorplanUpload,
  cleanEditHistory,
  setOriginalImageDimensions,
  addItemToEditHistory,
  setFloorImage,
  saveFloorImage,
  cancelFloorPlanImage,
  showCancelUpload,
  resetFloorplan,
  addSpace,
  setFloormapState,
  confirmAddSpace,
  cancelAddSpace,
  getSpaces,
  getSpacesSucceeded,
  getFloorSpacesSucceeded,
  toggleIndividialSpaces: toggleIndividualSpaces,
  toggleIndividialSpacesSuccess: toggleIndividualSpacesSuccess,
  toggleMettingSpaces: toggleMeetingSpaces,
  toggleAmenitySpaces,
  toggleSupportSpaces,
  toggleOnlyWithPhoto,
  toggleOnlyWithNote,
  updateSpace,
  updateSpaceBubblePosition,
  layersBuildSucceeded,
  seatCountClicked,
  spaceTypeClicked,
  photoFilterClicked,
  noteFilterClicked,
  showSeatCountLayer,
  showSpaceTypeLayer,
  setShowSpacesUSFLayer,
  enableSeatCountButton,
  setControlsState,
  restoreControlsState,
  setAddFloorNoteState,
  setSelectedSpace,
  clearSelectedSpace,
  getSpaceToUpdate,
  setSpaceToUpdate,
  attachNote,
  attachNoteSucceeded,
  enableAllViewLayers,
  addUnattachedNote,
  toggleOtherSpaces,
  deleteSpace,
  setIsLoadingFloorplanImage,
  toggleWorkspaceIntermediate,
  putDistanceConstant,
  setToolbarMode,
  setMeasurementState,
  startCopyingFloorUsfShape,
  cleanCopyingFloorUsfShapeState,
  copyMeasuredFloorUsf,
  finishedCopyingFloorUsfShape,
  populateCalibration,
  pushPointToArea,
  fetchCalibration,
  fetchCalibrationSucceeded,
  fetchSuggestedCalibration,
  fetchSuggestedCalibrationSucceeded,
  setSuggestedCalibration,
  updateSuggestedCalibration,
  setIsDrawingCalibration,
  setIsMeasuredShapeDirty,
  setPreviousMapBoundsAndZoom,
  setActiveShape,
  setOriginalShape,
  saveActiveShape,
  fetchFloorplanShapes,
  populateFloorplanShapes,
  updateShape,
  deleteActiveShape,
  deleteNote,
  updateNote,
  deleteShape,
  removeSpaceShape,
  populateClusters,
  updateCluster,
  deleteCluster,
  deleteClusterSucceded,
  deleteClusterFailed,
  createSpaceFromCluster,
  startPDFUpload,
  setIsUploadingPDF,
  setWorkingLayer,
  setSelectedSpaceLayers,
  setBulkSelectionState,
  deleteSelectedSpaces,
  createSpaces,
  updateMultipleSpaces,
  setSelectionShapePoints,
  setOriginalFileDataUrl,
  exitFloorplanOperation,
  exitFloorplanOperationConfirm,
  exitFloorplanOperationCancel,
  setTooltipPositionState,
  setMapMounted,
  fetchSpacesWorksheetSpreadsheet,
  fetchSpacesWorksheetSpreadsheetSuccess,
  fetchSpacesWorksheetSpreadsheetFailed,
  fetchFloorplanPDF,
  fetchFloorplanPDFSuccess,
  fetchFloorplanPDFFailed,
  setControlStateValue,
  setBulkOperationSourceFloorData,
  setFloorplanPreviewState,
  setFloorplanPreviewImageBounds,
  cropFloorplanImage,
  setAdjustedFloorplanItems,
  setThereAreChangesPendingForBulkOperation: setChangesForBulkOperationArePending,
};

export type Actions = ActionsUnion<typeof actions>;
